import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { auth, ApiError } from '../lib/api';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      await auth.resetPasswordRequest(email);
      setSuccess(true);
    } catch (err) {
      if (err instanceof ApiError) {
        setError(err.message);
      } else {
        setError('リクエストに失敗しました');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-jarvis-navy-dark via-jarvis-navy to-jarvis-navy-dark flex items-center justify-center px-4">
        <div className="w-full max-w-md">
          <div className="card text-center">
            <div className="text-6xl mb-4">📧</div>
            <h2 className="text-xl font-bold mb-4" style={{ color: 'var(--text-primary)' }}>
              メールを送信しました
            </h2>
            <p className="mb-6" style={{ color: 'var(--text-secondary)' }}>
              パスワードリセット用のリンクを<br />
              <strong>{email}</strong> に送信しました。<br />
              メールをご確認ください。
            </p>
            <Link to="/login" className="btn-primary inline-block">
              ログインページへ戻る
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-jarvis-navy-dark via-jarvis-navy to-jarvis-navy-dark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* ロゴ */}
        <div className="text-center mb-8">
          <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-jarvis-gold to-jarvis-gold-dark flex items-center justify-center">
            <span className="text-jarvis-navy-dark font-bold text-4xl">J</span>
          </div>
          <h1 className="text-white text-2xl font-bold">パスワードリセット</h1>
          <p className="text-gray-400 text-sm">Jarvis - Reactor Operation System</p>
        </div>

        {/* フォーム */}
        <div className="card">
          <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
            登録されているメールアドレスを入力してください。
            パスワードリセット用のリンクをお送りします。
          </p>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-red-500/10 border border-red-500/30 text-red-400 text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: 'var(--text-secondary)' }}>
                メールアドレス
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
                placeholder="your@email.com"
                required
                autoComplete="email"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="btn-primary w-full"
            >
              {isLoading ? 'リクエスト中...' : 'リセットリンクを送信'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/login"
              className="text-sm text-jarvis-gold hover:text-jarvis-gold-light transition-colors"
            >
              ← ログインに戻る
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

